import { Link } from 'react-router-dom';

export default function Navbar() {
  return (
    <header className="fixed top-0 left-0 right-0 z-[9998] bg-white shadow-[0_1px_3px_rgba(0,0,0,0.05)]">
      <div className="max-w-[1200px] mx-auto px-6 py-4 flex items-center justify-between relative">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src="https://cdn.prod.website-files.com/602f5458a0b1d868c6c84d5b/60307e489ca8621554af197d_logo2.webp"
            alt="Nanonets logo"
            width={123}
            height={30}
          />
        </div>

        {/* Center nav links */}
        <nav className="hidden md:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
          <a href="https://docstrange.nanonets.com/pricing/" className="text-sm font-medium text-[#08080899] hover:text-[#546FFF] transition-colors duration-200">Pricing</a>
          <a href="https://nanonets.com/ocr/blog" className="text-sm font-medium text-[#08080899] hover:text-[#546FFF] transition-colors duration-200">Blog</a>
          <a href="https://idp-leaderboard.org/" className="text-sm font-medium text-[#08080899] hover:text-[#546FFF] transition-colors duration-200">Benchmarks</a>
          <a href="https://docstrange.nanonets.com/docs" className="text-sm font-medium text-[#08080899] hover:text-[#546FFF] transition-colors duration-200">API Documentation</a>
        </nav>

        {/* Right buttons */}
        <div className="flex items-center gap-6">
          <Link
            to="/demo"
            className="text-sm font-medium text-[#08080899] hover:text-[#546FFF] transition-colors duration-200 hidden sm:block"
          >
            Book a call
          </Link>
          <Link
            to="https://docstrange.nanonets.com/app"
            className="px-8 py-2.5 bg-[#F8FAFF] text-[#546FFF] border-[1.5px] border-[#BBC5FF] rounded-lg text-sm font-medium hover:bg-[#EAEDFF] hover:border-[#546FFF] hover:scale-[1.02] hover:text-[#3A4DB2] transition-all duration-200 text-center whitespace-nowrap"
          >
            Start Free Trial
          </Link>
        </div>
      </div>
    </header>
  );
}
